import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CAMPAIGN_PLAY_TYPE } from "../../constants/campaignPlayTypes";
import { CAMPAIGN_STEPS } from "../../types/campaignTypes";

const ContextualAbmCreatePageRedesign: FC = () => (
  <CampaignBuilderForm
    mode="campaign"
    campaignPlayType={CAMPAIGN_PLAY_TYPE.CONTEXTUAL_ABM}
    visibleOptionalPanels={[CAMPAIGN_STEPS.PUBLICATION_LISTS, CAMPAIGN_STEPS.TARGET_COMPANIES]}
  />
);

export default ContextualAbmCreatePageRedesign;
